<template>
  <div class="login-page">
    <header class="login-topbar">
      <div class="mini-brand">
        <span class="mini-brand-mark">A</span>
        <span>ASM PACIFIC</span>
      </div>
      <button
        class="language-button"
        type="button"
        aria-label="切换语言"
        @click="$router.push('/language')"
      >
        <van-icon name="globe-o" />
        <span>简体中文</span>
      </button>
    </header>

    <div class="hero">
      <div class="hero-kicker"><i></i> GLOBAL WEALTH PLATFORM</div>
      <img
        class="asm-login-logo"
        src="../../assets/images/asmpt_logo.svg"
        alt="ASM Pacific"
      />
      <h1>让财富管理<br /><span>更专业、更从容</span></h1>
      <p>全球视野 · 专业研究 · 稳健服务</p>
      <div class="trust-row">
        <span><van-icon name="shield-o" /> 安全保障</span>
        <span><van-icon name="chart-trending-o" /> 专业策略</span>
        <span><van-icon name="service-o" /> 专属服务</span>
      </div>
    </div>

    <main class="login-main">
      <div class="form-heading">
        <small>WELCOME BACK</small>
        <h2>欢迎登录</h2>
        <p>登录您的 ASM 太平洋账户</p>
      </div>

      <label class="form-field">
        <span class="field-label">账户</span>
        <div class="field-control">
          <van-icon name="contact" />
          <input
            v-model.trim="emailName"
            type="text"
            autocomplete="username"
            placeholder="邮箱前缀；手机号请加 +"
          />
          <select
            v-if="!isPhoneAccount"
            v-model="emailSuffix"
            aria-label="邮箱后缀"
          >
            <option
              v-for="suffix in emailSuffixes"
              :key="suffix"
              :value="suffix"
            >
              {{ suffix }}
            </option>
          </select>
        </div>
      </label>

      <label class="form-field">
        <span class="field-label">登录密码</span>
        <div class="field-control">
          <van-icon name="lock" />
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            placeholder="请输入登录密码"
          />
          <button
            class="field-icon"
            type="button"
            aria-label="显示或隐藏密码"
            @click="showPassword = !showPassword"
          >
            <van-icon :name="showPassword ? 'eye-o' : 'closed-eye'" />
          </button>
        </div>
      </label>

      <div class="link-row">
        <button type="button" @click="login1">邮箱验证码登录</button>
        <button
          type="button"
          @click="$router.push({ name: 'RetrievePassword' })"
        >
          忘记密码？
        </button>
      </div>

      <van-button class="login-button" @click="submit">
        登录账户 <van-icon name="arrow" />
      </van-button>
      <p class="register-guide">
        还没有账户？
        <button type="button" @click="goTo">立即注册</button>
      </p>
    </main>

    <footer class="security-note">
      <van-icon name="shield-o" />
      <span>加密传输 · 隐私保护 · 安全访问</span>
    </footer>

    <div v-if="show" class="loading-mask">
      <div class="loading-box">
        <van-loading color="#ffffff" />
        <span>{{ $t("m.dl_span12") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";

const BACK_URL = "login_back_url";
const DEFAULT_EMAIL_SUFFIXES = [
  "@gmail.com",
  "@outlook.com",
  "@hotmail.com",
  "@icloud.com",
  "@yahoo.com",
  "@proton.me",
  "@aol.com",
  "@live.com",
  "@msn.com",
  "@mail.com",
  "@qq.com",
  "@foxmail.com",
  "@163.com",
  "@126.com",
  "@sina.com",
  "@yeah.net",
  "@naver.com",
  "@daum.net",
  "@yandex.com"
];

export default {
  name: "Login",
  data: function() {
    return {
      value: 86,
      show: false,
      emailName: "",
      emailSuffix: "@gmail.com",
      emailSuffixes: DEFAULT_EMAIL_SUFFIXES.slice(),
      password: "",
      showPassword: false,
      codeVal: "android"
    };
  },
  mounted: function() {
    const savedAccount = window.localStorage.getItem("zhanghao");
    if (savedAccount) {
      this.setEmailAccount(savedAccount);
    }
    if (window.localStorage.getItem("mima")) {
      this.password = window.localStorage.getItem("mima");
    }
    if (window.localStorage.getItem("quhao")) {
      this.value = window.localStorage.getItem("quhao");
    }
  },
  methods: {
    login1() {
      this.$router.push({
        path: "/login1"
      });
    },
    goTo() {
      this.$router.push({
        path: "/register"
      });
    },
    setEmailAccount(account) {
      const value = String(account || "").trim();
      const atIndex = value.indexOf("@");
      if (atIndex === -1) {
        // 历史保存的纯数字账号来自手机号登录；显式补上 +，避免与数字型邮箱前缀混淆。
        this.emailName = /^\d+$/.test(value) ? `+${value}` : value;
        return;
      }

      const suffix = value.slice(atIndex).toLowerCase();
      this.emailName = value.slice(0, atIndex);
      if (this.emailSuffixes.indexOf(suffix) === -1) {
        this.emailSuffixes.push(suffix);
      }
      this.emailSuffix = suffix;
    },
    getEmailAccount() {
      const account = String(this.emailName || "").trim();
      if (!account) {
        return "";
      }
      // 手机号必须显式使用 + 前缀；纯数字默认按 QQ 等数字型邮箱前缀处理。
      if (/^\+\d+$/.test(account)) {
        return account.slice(1);
      }
      if (/^[^@]+@[^@]+$/.test(account)) {
        return account.toLowerCase();
      }
      const emailName = account.replace(/@+$/, "");
      return `${emailName}${this.emailSuffix}`.toLowerCase();
    },
    async submit() {
      const emailAccount = this.getEmailAccount();
      const { password, codeVal } = this;
      try {
        await this.$validator({
          emailAccount: [required(required.message("邮箱或手机号"))],
          password: [required(required.message("密码"))]
        }).validate({
          emailAccount,
          password
        });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      this.show = true;
      login({
        area: this.value,
        username: emailAccount,
        password,
        system: codeVal
      })
        .then(data => {
          this.show = false;
          let expires_time = new Date().getTime() + 86400 * 1000 - 28800000;
          const datas = {
            token: data.data.data.access_token,
            expires_time: expires_time,
            kf: data.data.data.kf,
            view: data.data.data.view
          };

          window.localStorage.setItem("zhanghao", emailAccount);
          window.localStorage.setItem("quhao", this.value);
          window.localStorage.setItem("mima", password);
          this.$store.commit("LOGIN", datas);
          cookie.remove(BACK_URL);
          this.$router.push({
            path: "/user"
          });
        })
        .catch(e => {
          this.show = false;
          this.$dialog.error(e.response.data.msg);
        });
    }
  },
  computed: {
    isPhoneAccount() {
      return /^\+\d+$/.test(String(this.emailName || "").trim());
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  color: #182033;
  padding: 22px 32px 56px;
  box-sizing: border-box;
}

.login-page::before {
  content: none;
  position: absolute;
  left: -138px;
  bottom: -118px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: repeating-radial-gradient(
    circle,
    rgba(3, 114, 251, 0.12) 0,
    rgba(3, 114, 251, 0.12) 1px,
    transparent 2px,
    transparent 9px
  );
}

.login-page::after {
  content: none;
  position: absolute;
  left: 0;
  right: 0;
  top: 330px;
  height: 170px;
  opacity: 0.16;
  background:
    linear-gradient(90deg, transparent 0 7%, rgba(201, 42, 42, 0.22) 7% 10%, transparent 10% 22%, rgba(3, 114, 251, 0.2) 22% 25%, transparent 25% 41%, rgba(201, 42, 42, 0.18) 41% 44%, transparent 44% 64%, rgba(3, 114, 251, 0.18) 64% 67%, transparent 67%),
    linear-gradient(0deg, transparent 49%, rgba(24, 32, 51, 0.24) 50%, transparent 51%);
}

.login-topbar,
.hero,
.login-main {
  position: relative;
  z-index: 1;
}

.login-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-button {
  width: 32px;
  height: 32px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #172033;
  font-size: 24px;
}

.line-select {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #172033;
  font-size: 15px;
}

.line-select strong {
  font-size: 20px;
  font-weight: 700;
}

.hero {
  min-height: 190px;
  padding-top: 44px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.asm-login-logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.asm-login-logo > span {
  display: grid;
  width: 72px;
  height: 72px;
  place-items: center;
  color: #fff;
  font-size: 21px;
  font-weight: 800;
  background: linear-gradient(145deg, #092d68, #1772c4);
  border-radius: 22px;
  box-shadow: 0 14px 28px rgba(17, 81, 153, 0.2);
}

.asm-login-logo strong,
.asm-login-logo small {
  display: block;
}

.asm-login-logo strong {
  color: #0a3977;
  font-size: 27px;
  letter-spacing: 1px;
}

.asm-login-logo small {
  margin-top: 5px;
  color: #7890ab;
  font-size: 10px;
  letter-spacing: 1.4px;
}

.server-visual {
  position: relative;
  width: 188px;
  height: 152px;
  border-radius: 26px;
  background:
    linear-gradient(150deg, rgba(255, 255, 255, 0.92), rgba(3, 114, 251, 0.16)),
    linear-gradient(45deg, transparent, rgba(201, 42, 42, 0.18));
  box-shadow: 0 22px 48px rgba(3, 114, 251, 0.18);
}

.server-card {
  position: absolute;
  left: 38px;
  top: 34px;
  width: 102px;
  height: 78px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.82);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 9px;
  padding-bottom: 16px;
}

.server-card::before {
  content: "";
  position: absolute;
  width: 68px;
  height: 68px;
  border: 6px solid rgba(201, 42, 42, 0.22);
  border-left-color: transparent;
  border-radius: 50%;
  right: -34px;
  top: -18px;
  transform: rotate(32deg);
}

.server-card span {
  width: 12px;
  border-radius: 8px 8px 4px 4px;
  background: linear-gradient(180deg, #0372fb, #c92a2a);
}

.server-card span:nth-child(1) {
  height: 28px;
}

.server-card span:nth-child(2) {
  height: 48px;
}

.server-card span:nth-child(3) {
  height: 36px;
}

.login-main h1 {
  margin: 0;
  font-size: 25px;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: 0;
}

.company-name {
  margin: 18px 0 42px;
  font-size: 18px;
  line-height: 1.45;
  color: #242c3d;
}

.form-row {
  height: 62px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(24, 32, 51, 0.22);
}

.form-row label {
  width: 44px;
  flex: 0 0 44px;
  color: #2d3445;
  font-size: 15px;
  font-weight: 600;
}

.form-row input {
  min-width: 0;
  flex: 1;
  height: 58px;
  border: 0;
  outline: none;
  background: transparent;
  color: #172033;
  font-size: 16px;
}

.form-row input::placeholder {
  color: rgba(24, 32, 51, 0.3);
}

.form-row select {
  flex: 0 0 auto;
  max-width: 132px;
  height: 42px;
  border: 0;
  outline: none;
  background: transparent;
  color: #2b3449;
  font-size: 15px;
  text-align: right;
}

.field-icon {
  width: 38px;
  height: 38px;
  border: 0;
  padding: 0;
  background: transparent;
  color: rgba(24, 32, 51, 0.58);
  font-size: 20px;
}

.link-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  color: #c92a2a;
  font-size: 15px;
}

.link-row span {
  cursor: pointer;
}

.login-button {
  width: 100%;
  height: 54px;
  margin-top: 28px;
  border: 0;
  border-radius: 6px;
  background: linear-gradient(90deg, #0372fb, #155bd4);
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}

.register-link {
  width: 100%;
  border: 0;
  background: transparent;
  color: #c92a2a;
  font-size: 17px;
  line-height: 52px;
  margin-top: 10px;
}

.loading-mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.loading-box {
  background: rgba(0, 0, 0, 0.74);
  width: 130px;
  height: 130px;
  border-radius: 8px;
  text-align: center;
  line-height: 130px;
  color: #fff;
  font-size: 16px;
}

@media (max-width: 360px) {
  .login-page {
    padding-left: 24px;
    padding-right: 24px;
  }

  .company-name {
    font-size: 16px;
  }

  .form-row {
    gap: 8px;
  }

  .form-row select {
    max-width: 112px;
    font-size: 14px;
  }
}

/* Premium auth refresh — navy, brand red and neutral surfaces only. */
.login-page {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 22px 22px 30px;
  color: #eaf2fb;
  background:
    linear-gradient(155deg, rgba(6, 26, 49, 0.98), rgba(10, 45, 80, 0.96)),
    url("../../assets/images/asm-premium/global-headquarters.webp") center / cover;
}

.login-page::before {
  content: "";
  inset: 0;
  width: auto;
  height: auto;
  border-radius: 0;
  opacity: 0.22;
  background-image:
    linear-gradient(rgba(121, 178, 224, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(121, 178, 224, 0.08) 1px, transparent 1px);
  background-size: 38px 38px;
}

.login-page::after {
  content: "";
  top: auto;
  right: -120px;
  bottom: -180px;
  left: auto;
  width: 390px;
  height: 390px;
  opacity: 1;
  border: 1px solid rgba(114, 184, 236, 0.13);
  border-radius: 50%;
  background: transparent;
  box-shadow:
    0 0 0 45px rgba(114, 184, 236, 0.035),
    0 0 0 90px rgba(114, 184, 236, 0.02);
}

.login-topbar,
.hero,
.login-main,
.security-note {
  position: relative;
  z-index: 2;
}

.mini-brand {
  display: flex;
  align-items: center;
  color: rgba(230, 240, 250, 0.78);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1.3px;
}

.mini-brand-mark {
  display: grid;
  width: 27px;
  height: 27px;
  margin-right: 8px;
  color: #fff;
  place-items: center;
  background: #a9332c;
  border-radius: 8px;
}

.language-button {
  display: flex;
  height: 32px;
  padding: 0 11px;
  align-items: center;
  color: rgba(235, 244, 252, 0.86);
  font-size: 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
}

.language-button i {
  margin-right: 5px;
  font-size: 13px;
}

.hero {
  display: block;
  min-height: 0;
  padding: 52px 5px 27px;
}

.hero-kicker {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  color: #a6c6df;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 1.8px;
}

.hero-kicker i {
  width: 21px;
  height: 1px;
  margin-right: 8px;
  background: #a9332c;
}

.asm-login-logo {
  display: block;
  width: 170px;
  height: auto;
  margin: 0 0 22px;
  padding: 8px 11px;
  background: rgba(255, 255, 255, 0.94);
  border-radius: 8px;
  box-shadow: none;
}

.hero h1 {
  margin: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 650;
  line-height: 1.3;
}

.hero h1 span {
  color: #b9d8ef;
}

.hero > p {
  margin: 11px 0 18px;
  color: rgba(218, 234, 247, 0.64);
  font-size: 11px;
  letter-spacing: 0.8px;
}

.trust-row {
  display: flex;
  gap: 7px;
}

.trust-row span {
  display: flex;
  padding: 6px 8px;
  align-items: center;
  color: rgba(230, 240, 249, 0.76);
  font-size: 9px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
}

.trust-row i {
  margin-right: 4px;
  color: #75b7e6;
}

.login-main {
  padding: 23px 20px 19px;
  color: #172b43;
  background: rgba(255, 255, 255, 0.975);
  border: 1px solid rgba(255, 255, 255, 0.76);
  border-radius: 20px;
  box-shadow: 0 24px 55px rgba(0, 12, 29, 0.3);
}

.form-heading small {
  color: #a9332c;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 1.5px;
}

.form-heading h2 {
  margin: 5px 0 0;
  color: #102a46;
  font-size: 21px;
}

.form-heading p {
  margin: 6px 0 20px;
  color: #8290a2;
  font-size: 10px;
}

.form-field {
  display: block;
  margin-top: 12px;
}

.field-label {
  display: block;
  margin: 0 0 7px 2px;
  color: #52647a;
  font-size: 10px;
  font-weight: 650;
}

.field-control {
  display: flex;
  min-height: 47px;
  padding: 0 12px;
  align-items: center;
  background: #f4f7fa;
  border: 1px solid #e3eaf1;
  border-radius: 12px;
}

.field-control:focus-within {
  background: #fff;
  border-color: #6da9d5;
  box-shadow: 0 0 0 3px rgba(37, 135, 206, 0.1);
}

.field-control > i {
  margin-right: 9px;
  color: #668099;
  font-size: 16px;
}

.field-control input {
  min-width: 0;
  height: 45px;
  padding: 0;
  flex: 1;
  color: #172b43;
  font-size: 12px;
  background: transparent;
  border: 0;
  outline: none;
}

.field-control select {
  max-width: 113px;
  height: 32px;
  padding-left: 7px;
  color: #425a72;
  font-size: 10px;
  background: transparent;
  border: 0;
  border-left: 1px solid #dbe4ed;
}

.field-icon {
  display: grid;
  width: 29px;
  height: 29px;
  padding: 0;
  color: #74869a;
  place-items: center;
  background: none;
  border: 0;
}

.link-row {
  margin-top: 14px;
}

.link-row button {
  padding: 0;
  color: #4d6d8b;
  font-size: 10px;
  background: none;
  border: 0;
}

.login-button {
  height: 47px;
  margin-top: 21px;
  color: #fff;
  font-size: 13px;
  background: linear-gradient(105deg, #0d3b67, #1778b9);
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(18, 90, 143, 0.22);
}

.login-button i {
  margin-left: 6px;
}

.register-guide {
  margin: 14px 0 0;
  color: #8794a3;
  font-size: 10px;
  text-align: center;
}

.register-guide button {
  padding: 0;
  color: #a9332c;
  font-size: inherit;
  font-weight: 700;
  background: none;
  border: 0;
}

.security-note {
  display: flex;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
  color: rgba(211, 227, 240, 0.54);
  font-size: 8px;
  letter-spacing: 0.7px;
}

.security-note i {
  margin-right: 5px;
}

.loading-mask {
  inset: 0;
  width: auto;
  height: auto;
  background: rgba(3, 17, 34, 0.66);
  backdrop-filter: blur(6px);
}

.loading-box {
  display: flex;
  width: auto;
  min-width: 116px;
  height: auto;
  padding: 17px 20px;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: normal;
  background: rgba(11, 40, 70, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
}

.loading-box span {
  margin-left: 10px;
}

@media (max-height: 700px) {
  .hero {
    padding-top: 28px;
    padding-bottom: 19px;
  }

  .asm-login-logo {
    width: 148px;
    margin-bottom: 16px;
  }

  .hero h1 {
    font-size: 24px;
  }

  .trust-row {
    display: none;
  }
}
</style>
